<template>
  <div class="leoshop leopages">
    <!-- 	<CubePage :backurl="'/my'" type="catcheck-view" :title="store.storename"
    v-if="store != null && store != undefined">-->
    <div>
      <van-sticky>
        <div
          class="leoshop-t"
          style="padding: 0;"
          :style="'background-color:'+gcfg.BackgroundColor"
        >
          <div
            class="gd-top"
            style="display: flex;align-items: center;"
            :style="'background-color:'+gcfg.BackgroundColor"
          >
            <div class="searchbox" style="flex: 1;">
              <div class="searchbox-item">
                <div class="lefticon">
                  <van-icon name="search"/>
                </div>
                <div class="righttitle" @click="goSearchPage">
                  <span>点击搜索</span>
                </div>
              </div>
            </div>
            <!-- <div class="lefttext" @click="onCell" style="padding-right: 15px;">
								<van-icon name="phone" size="20px" color="#00aa00" style="vertical-align: middle;" />
								<span style="font-size: 13px;color: #000;">联系店主</span>
            </div>-->
          </div>
          <div
            class="shop-xx"
            style="padding: 10px 15px;"
            v-if="store != null && store != undefined"
          >
            <div class="shop-tx">
              <van-image :src="store.avatar" fit="scale-down"/>
            </div>
            <div class="shop-xq">
              <div class="shop-name" @click="goShopNamePage">
                <p class="name-p">
                  <span class="name ells">{{store.storename}}</span>
                  <span class="name-go">
                    <!-- <van-icon name="arrow" /> -->
                  </span>
                </p>
                <p class="shop-name-tips ells">{{store.notice}}</p>
              </div>
              <div class="btns">
                <van-button round v-if="collect != '10'" @click="handelSc">
                  <van-icon name="star-o"/>收藏
                </van-button>
                <van-button round class="ysc" v-else @click="handelSc">已收藏</van-button>
                <van-button style="margin-left: 5px;" round @click="isFxShow =true">
                  <van-icon name="share-o"/>分享
                </van-button>
              </div>
            </div>
          </div>
        </div>
      </van-sticky>

      <div class="leoshop-content content-index">
        <van-swipe
          class="swipebox"
          v-if="bannerone"
          :autoplay="3000"
          lazy-render
          style="height: 180px;"
        >
          <van-swipe-item v-for="(item,index) in bannerone" :key="index">
            <img :src="item.image">
          </van-swipe-item>
        </van-swipe>
        <div class="grid-box grid-box5">
          <div
            class="grid-item grid-item5 bgcolor"
            v-for="(item,index) in recommendData"
            :key="index"
            @click="goPageList(index)"
          >
            <van-icon
              v-if="item.name.indexOf('门票') != -1"
              class="van-icon iconfont"
              name="ziyuan3"
              class-prefix="icon"
            />
            <van-icon
              v-else-if="item.name.indexOf('酒店') != -1"
              class="van-icon iconfont"
              name="jiudian"
              class-prefix="icon"
            />
            <van-icon
              v-else-if="item.name.indexOf('度假') != -1"
              class="van-icon iconfont"
              name="lvyou1"
              class-prefix="icon"
            />
            <van-icon
              v-else-if="item.name.indexOf('美食') != -1"
              class="van-icon iconfont"
              name="meishika"
              class-prefix="icon"
            />
            <van-icon
              v-else-if="item.name.indexOf('包车') != -1"
              class="van-icon iconfont"
              name="yongche"
              class-prefix="icon"
            />
            <van-icon
              v-else-if="item.name.indexOf('拍') != -1"
              class="van-icon iconfont"
              name="xiangji"
              class-prefix="icon"
            />
            <van-icon
              v-else-if="item.name.indexOf('直通车') != -1"
              class="van-icon iconfont"
              name="zhitongche"
              class-prefix="icon"
            />
            <van-icon
              v-else-if="item.name.indexOf('特产') != -1"
              class="van-icon iconfont"
              name="tutechan"
              class-prefix="icon"
            />
            <van-icon
              v-else-if="item.name.indexOf('晚会') != -1"
              class="van-icon iconfont"
              name="wutai"
              class-prefix="icon"
            />
            <van-icon
              v-else-if="item.name.indexOf('巴士') != -1"
              class="van-icon iconfont"
              name="bus"
              class-prefix="icon"
            />
            <van-icon v-else class="van-icon iconfont" name="weibiaoti1" class-prefix="icon"/>
            <p class="name">{{item.name}}</p>
          </div>
        </div>

        <div class="gg jxbg" v-if="destination.length>0">
          <div class="title">
            <div class="left colorb">
              <div class="bsize">精选目的地</div>
              <div class="desc">尖货精选 宝藏推荐</div>
            </div>
            <div class="rigth">
              <p class="bgbtn">
                目的地大全
                <van-icon name="play"/>
              </p>
            </div>
          </div>
          <van-swipe
            class="grid-box"
            :loop="false"
            :show-indicators="false"
            :width="120"
            :height="110"
          >
            <van-swipe-item
              class="grid-item"
              style="padding-right: 10px;"
              v-for="item in destination"
              :key="item.id"
              @click="goPlnew(item)"
            >
              <van-image class="ggimg" fit="cover" :src="item.image" radius="10">
                <div class="gg-tname" style="width: 90%;
      position: absolute;
      bottom: 5px;
      left: 0;
      margin-left: 10px;
      margin-right: 5px;
      color: #fff;">
                  <div class="jqname ells">{{item.name}}</div>
                </div>
              </van-image>
            </van-swipe-item>
          </van-swipe>
          <img class="bgimg" src="../../assets/img/bg1.png" alt>
        </div>
        <div>
          <van-swipe
            class="swipebox"
            v-if="bannertow"
            style="height: 100px;"
            :autoplay="3500"
            lazy-render
          >
            <van-swipe-item v-for="(item,index) in bannertow" :key="index">
              <img :src="item.image">
            </van-swipe-item>
          </van-swipe>
        </div>
        <div class="listdata">
          <div class="listdata-title" :style="'background-color:'+gcfg.BackgroundColor">
            <span :style="'color:'+gcfg.TopTextColor">热销推荐</span>
          </div>
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            :immediate-check="false"
          >
            <van-cell v-for="(item,index) in list" :key="index">
              <div class="cell-item" @click="goGoodsDetail(item.goods_id)">
                <div class="leftimg">
                  <van-image :src="item.images" fit="cover"></van-image>
                </div>
                <div class="right-content">
                  <div class="title ells">{{item.goods_name}}</div>
                  <div class="remark" style="overflow: hidden;">
                    <p class="ells" v-for="desc in item.describe.split('<br/>')">{{desc}}</p>
                    <!-- <p class="ells2" style="white-space: pre-wrap;" v-html="item.describe"></p> -->
                  </div>
                  <div class="price">
                    <div class="yj">
                      <!-- 原价<span>￥{{item.line_price}}</span> -->
                    </div>
                    <div class="xj">
                      ￥
                      <span>{{item.goods_price}}</span>
                    </div>
                  </div>
                  <div class="xse">
                    已售：
                    <span>{{item.sales}}</span>份
                  </div>
                </div>
              </div>
            </van-cell>
          </van-list>
        </div>
      </div>
    </div> 
    <!-- 	</CubePage> -->
    <van-popup @click="isFxShow=false" v-model="isFxShow" style="width: 100%;height: 100%;">
      <img style="width: 100%;height: 100%;" src="@/assets/img/fx.jpg" alt>
    </van-popup>
    <float-icons padding="10 10 60 10" class="icons-warp">
      <div class="float-icon-item" @click="goMy">
        <van-icon size="20" name="manager-o"/>
        <span>我的</span>
      </div>
      <div class="float-icon-item" @click="goOder">
        <van-icon size="20" name="orders-o"/>
        <span>订单</span>
      </div>
      <div class="float-icon-item" @click="onCell">
        <van-icon size="20" name="phone-o"/>
        <span>店主</span>
      </div>
    </float-icons>
  </div>
</template>

<script>
import CubePage from "../TP/cube-page.vue";
import FloatIcons from "@/components/TP/s-icons";
import * as util from "@/utils/network";
import wx from "weixin-js-sdk";
import { Toast, Dialog } from "vant";
export default {
  components: {
    CubePage,
    FloatIcons
  },
  data() {
    return {
      isFxShow: false,
      isBack: this.$route.query.isBack ? true : false,
      showShare: false,
      list: [],
      loading: false,
      finished: false,
      activeName: "",
      bannerone: [],
      bannertow: [],
      ggitems: [],
      recommendData: [],
      isNoData: false,
      pageIndex: 1,
      pageTotal: 0,
      isSc: false,
      re_value: "",
      gcfg: [],
      store: null,
      storeId: this.$route.query.store_id,
      collect: "0", //是否收藏
      destination: []
    };
  },
  methods: {
    //去查询界面
    goPlnew(item) {
      this.$router.push({
        path: "/plnew",
        query: {
          scenic_spots_id: item.id,
		  scenic_spots_name: item.name,
		  store_id:this.storeId
        }
      });
    },
    getSwiperData() {
      var url = "/addons/litestore/api.goodsscenic/selectpage";
      let that = this;

      //这里直接调用网络接口
      util.get(url, {}, function(result) {
        console.log(result.list);
        that.destination = result.list;
      });
    },
    goPageList(v) {
      this.$router.push({
        name: "SearchPage",
        params: {
          active: v,
          isSj: "false"
        }
      });
    },
    getSidebarData() {
      var url = "/addons/litestore/api.category/Showlist";
      let that = this;

      //这里直接调用网络接口
      util.get(url, {}, function(result) {
        that.recommendData = result["data"]["categorydata"];
      });
    },
    goMy() {
      this.$router.push({
        name: "My"
      });
    },
    goOder() {
      util.redirect("myorder/list?showType=0");
    },
    // 初始化数据
    clearData() {},
    onCell() {
      window.location.href = "tel://" + this.store.mobile;
    },
    // 打开分享界面
    onSelect() {
      let that = this;
    },
    // 去商品详情页
    goGoodsDetail(v) {
      //leo
      util.redirect("goodsdetail?id=" + v + "&type=spxq&isSj=false");
      /*this.$router.push({
					path: '/goodsdetail',
					query: {
						type: 'spxq',
						isSj: 'false',
						id: v
					}
				})*/
    },
    // 去查询界面
    goSearchPage() {
      this.$router.push({
        path: "/searchpage",
        query: {
          isSj: "false"
        }
      });
    },
    // 去店铺信息详情页面
    goShopNamePage() {
      this.$router.push({
        path: "/shopxq"
      });
    },
    // 收藏按钮功能
    handelSc() {
      let that = this;
      let msg = "";
      var url = "/addons/litestore/api.account/collect";
      //这里直接调用网络接口
      util.post(
        url,
        {
          store_id: that.storeId
        },
        function(result) {
          Toast(result.msg);
          setTimeout(() => {
            that.getData();
          }, 1000);
        }
      );
    },
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      let that = this;
      // 异步更新数据
      that.pageIndex++;
      setTimeout(() => {
        that.getListData();
      }, 1000);
    },
    // 获取banner数据
    getData() {
      let that = this;
      var url = "/addons/litestore/api.shop/store";
      //这里直接调用网络接口
      util.post(
        url,
        {
          store_id: that.storeId
        },
        function(result) {
          that.ggitems = [];
          that.collect = result.data.collect;
          that.store = result.data.store;
          that.bannerone = result.data.banner.top;
          that.bannertow = result.data.banner.bottom;
          that.ggitems.push(result.data.banner.left);
          that.ggitems.push(result.data.banner.right);
          that.$store.commit("setShop", result.data.store.id);
        }
      );
    },
    // 获取列表数据
    getListData() {
      let that = this;
      var url = "/addons/litestore/api.shop/storeProductList";
      let param = {
        page: that.pageIndex,
        store_id: that.storeId
      };
      //这里直接调用网络接口
      util.post(url, param, function(result) {
        let data = result.data;
        that.loading = false;
        //这里对状态 进行分类
        that.pageTotal = data.total;
        if (that.pageTotal < 1) {
          that.isNoData = true;
          return;
        }
        if (data.list == null || data.list.length === 0) {
          // 加载结束
          that.finished = true;
          return;
        }
        // 将新数据与老数据进行合并
        that.list = that.list.concat(data.list);

        //如果列表数据条数>=总条数，不再触发滚动加载
        if (that.list.length >= that.pageTotal) {
          that.finished = true;
        }
      });
    }
  },
  created() {
    this.gcfg = this.$store.getters.getGcfg;
    this.storeId = this.$route.query.store_id;
    if (this.storeId != "") {
      this.getSwiperData();
      this.getSidebarData();
      this.getData();
      this.getListData();
    } else {
      Dialog.alert({
        title: "温馨提示",
        message: "该店铺不存在"
      }).then(() => {
        window.opener = null;
        window.open("about:blank", "_top").close();
      });
    }
  },
  watch: {
    "$store.state.gcfg"() {
      this.gcfg = this.$store.getters.getGcfg;
    }
  }
};
</script>
<style lang="less" scoped="scoped">
@import url("../../assets/css/base.less");
@import url("../../assets/css/listboxless.less");
.content-index {
  background-color: #ffffff;
}
.grid-box {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0;
  padding: 10px 10px 0 10px;
  // margin-top: 10px;

  .grid-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
  }

  .grid-item2 {
    min-width: 0;
    flex-basis: 48.5%;

    .img {
      height: 110px;
    }
  }

  .grid-item3 {
    min-width: 0;
    flex-basis: 32.5%;

    .img {
      height: 138px;
    }
  }

  .grid-item5 {
    min-width: 0;
    flex-basis: 19.5%;

    .van-icon {
      font-size: 32px;
      padding-top: 10px;
    }

    .name {
      padding-bottom: 10px;
    }
  }

  .grid-item5:first-child {
    border-top-left-radius: 15px;
  }

  .grid-item5:last-child {
    border-bottom-right-radius: 15px;
  }

  .grid-item5:nth-child(5) {
    border-top-right-radius: 15px;
  }

  .grid-item5:nth-child(6) {
    border-bottom-left-radius: 15px;
  }

  .bgcolor {
    color: #fff;

    .name {
      margin-top: 5px;
      font-size: 14px;
      text-align: center;
    }
  }

  .bgcolor:nth-child(n + 6) {
    color: #000;
  }

  .bgcolor:first-child {
    background: linear-gradient(#f95f55, #fa8051);
  }

  .bgcolor:nth-child(2) {
    background: linear-gradient(#3e87fa, #4daafa);
  }

  .bgcolor:nth-child(3) {
    background: linear-gradient(#6084ff, #649eff);
  }

  .bgcolor:nth-child(4) {
    background: linear-gradient(#20bcaf, #1accbe);
  }

  .bgcolor:nth-child(5) {
    background: linear-gradient(#ff8a3a, #fea444);
  }

  .bgcolor:nth-child(6) {
    background-color: #fef4f2;

    .van-icon {
      color: #fd754d;
    }
  }

  .bgcolor:nth-child(7) {
    background-color: #eff8ff;

    .van-icon {
      color: #4599fc;
    }
  }

  .bgcolor:nth-child(8) {
    background-color: #f1f3ff;

    .van-icon {
      color: #7e84fe;
    }
  }

  .bgcolor:nth-child(9) {
    background-color: #ecfbf8;

    .van-icon {
      color: #50d2b6;
    }
  }

  .bgcolor:nth-child(10) {
    background-color: #fff9f1;

    .van-icon {
      color: #fd802c;
    }
  }
}

.grid-box5 {
  justify-content: space-around;
}

.icons-warp {
  border-radius: 20px;
  // background: linear-gradient(to right, rgba(76, 168, 255) 60%, rgba(60, 192, 255)) !important;
  background: linear-gradient(#ff8a3a, #fea444) !important;

  .float-icon-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 50px;
    height: 50px;
    color: #fff;

    img {
      width: 25px;
      height: 25px;
      margin-bottom: 3px;
    }

    span {
      font-size: 9px;
      // color: #666666;
    }
  }
}

.gg {
  margin: 10px;
  padding: 10px;
  border-radius: 15px;
  box-shadow: 1px 0 1px 0 #f8f8f8;

  .ggimg.van-image {
    width: 100%;
    font-size: 12px;
  }

  .title {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 5px;

    .left {
      color: #ff5b00;
    }

    .rigth {
      display: flex;

      .bgbtn {
        padding: 3px 6px;
        font-size: 14px;
        background: rgba(255, 255, 255, 0.8);
        border-radius: 15px;
      }
    }

    .bsize {
      font-size: 20px;
      padding-right: 15px;
      font-weight: 600;
    }

    .colorb {
      color: #435084;
    }

    .desc {
      padding-top: 2px;
      font-size: 15px;
    }
  }
}
 
.jxbg {
  position: relative;
  z-index: 1;

  .bgimg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    opacity: 0.5;
    z-index: -1;
    border-radius: 10px;
  }
  .ggimg{
    position: relative;
	box-sizing: border-box;
	.gg-tname{
      width: 90%;
      position: absolute;
      bottom: 5px;
      left: 0;
      margin-left: 10px;
      margin-right: 5px;
	  color: #fff;
	   span {
        font-size: 14px;
      }

      .jqname {
        font-size: 14px;
        padding-bottom: 5px;
      }
	}
  }
}
</style>
